<div class="ui-g-12 p-0 flex-start-center width-100p mb-4 mt-10" *ngIf="!isMyFleetCenter">
  <p class="m-0 font-bold font-gray-35 white-space-nowrap pr-2">Order level override</p>
  <div class="horizontal-line width-100p mr-2"></div>
</div>

<!-- Order discount -->
<div class="ui-g-12 p-0 mb-4">
  <div class="ui-g-4 p-0 pr-2">
    <app-switch-pill id="fleet-order-discount" label="Apply default order discount" position="end"
      styleClassLabel="font-gray-35" [fontSize]="14" [isActive]="fleetSettings?.isOrderDiscOverride"
      (appChange)="handleAppSettingChange('isOrderDiscOverride', $event)">
    </app-switch-pill>
  </div>

  <div class="ui-g-3 p-0 pr-2">
    <app-dropdown id="fleet-order-discount-type" listId="fleet-order-discount-type-list" placeholder="Calculation"
      theme="primary" field="label" [disabled]="!fleetSettings?.isOrderDiscOverride"
      [hasError]="errors?.customOrderDiscountType" [errorMessage]="errors?.customOrderDiscountType"
      [value]="fleetSettings?.customOrderDiscountType" [fontSize]="14" [listItemFontSize]="13" [floatingLabel]="true"
      [options]="calculationTypes" [isDropdownIconVisible]="true"
      (appSelect)="handleAppSettingChange('customOrderDiscountType', $event)" [theme]="inputTheme">
    </app-dropdown>
  </div>

  <div class="flex-row ui-g-5 p-0">
    <div class="p-0 pr-2 mb-4"
      [ngClass]="fleetSettings?.customOrderDiscountType?.value === 'percentage' ? 'ui-g-6' : 'ui-g-12'">
      <app-input id="fleet-order-discount-value" placeholder="Value" theme="primary" name="fleet-order-discount-value"
        [floatingLabel]="true" [fontSize]="14" [isInvalid]="errors?.customOrderDiscountValue"
        [errorMessage]="errors?.customOrderDiscountValue"
        [allowDecimal]="fleetSettings?.customOrderDiscountType?.value !== 'percentage'"
        [disabled]="!fleetSettings?.isOrderDiscOverride" [value]="addPercentageOrCurrency()" [selectTextOnFocus]="true"
        (appFocus)="handleFocus('customOrderDiscountValue')" (appBlur)="handleBlur('customOrderDiscountValue')"
        (appKeyUp)="handleAppSettingChange('customOrderDiscountValue', $event)" [theme]="inputTheme">
      </app-input>
    </div>
    <div class="ui-g-6 p-0 pr-2" *ngIf="fleetSettings?.customOrderDiscountType?.value === 'percentage'">
      <app-input id="fleet-shop-supplies-cap" placeholder="Max discount" theme="primary" name="fleet-shop-supplies-cap"
        [allowDecimal]="focus?.customOrderDiscountCap ? true: false" [floatingLabel]="true" [fontSize]="14"
        [isInvalid]="errors?.customOrderDiscountCap" [errorMessage]="errors?.customOrderDiscountCap"
        [value]="focus?.customOrderDiscountCap? fleetSettings?.customOrderDiscountCap: fleetSettings?.customOrderDiscountCap | currency: usd"
        [selectTextOnFocus]="true" (appFocus)="handleFocus('customOrderDiscountCap')"
        (appBlur)="handleBlur('customOrderDiscountCap')"
        (appKeyUp)="handleAppSettingChange('customOrderDiscountCap', $event)" [theme]="inputTheme">
      </app-input>
    </div>
  </div>

  <!-- Shop supplies -->
  <div class="ui-g-12 p-0 mb-4">
    <div class="ui-g-4 p-0 pr-2">
      <app-switch-pill id="fleet-shop-supplies" label="Apply shop supplies override" position="end"
        styleClassLabel="font-gray-35" [fontSize]="14" [isActive]="fleetSettings?.isShopSuppliesOverride"
        (appChange)="handleAppSettingChange('isShopSuppliesOverride', $event)">
      </app-switch-pill>
    </div>

    <div class="ui-g-3 p-0 pr-2">
      <app-dropdown id="fleet-shop-supplies-type" listId="fleet-shop-supplies-type-list" placeholder="Calculation"
        theme="primary" field="label" [disabled]="!fleetSettings?.isShopSuppliesOverride"
        [hasError]="errors?.customShopSuppliesType" [errorMessage]="errors?.customShopSuppliesType"
        [value]="fleetSettings?.customShopSuppliesType" [fontSize]="14" [listItemFontSize]="13" [floatingLabel]="true"
        [options]="calculationTypes" [isDropdownIconVisible]="true"
        (appSelect)="handleAppSettingChange('customShopSuppliesType', $event)" [theme]="inputTheme">
      </app-dropdown>
    </div>

    <div class="flex-row ui-g-5 p-0">
      <div class="p-0 pr-2"
        [ngClass]="fleetSettings?.customShopSuppliesType?.value === 'percentage' ? 'ui-g-6' : 'ui-g-12'">
        <app-input id="fleet-shop-supplies-value" placeholder="Value" theme="primary" name="fleet-shop-supplies-value"
          [floatingLabel]="true" [fontSize]="14" [isInvalid]="errors?.customShopSuppliesValue"
          [errorMessage]="errors?.customShopSuppliesValue"
          [allowDecimal]="fleetSettings?.customShopSuppliesType?.value !== 'percentage'"
          [disabled]="!fleetSettings?.isShopSuppliesOverride" [value]="addShopSupply()" [selectTextOnFocus]="true"
          (appFocus)="handleFocus('customShopSuppliesValue')" (appBlur)="handleBlur('customShopSuppliesValue')"
          (appKeyUp)="handleAppSettingChange('customShopSuppliesValue', $event)" [theme]="inputTheme">
        </app-input>
      </div>
      <div class="ui-g-6 p-0 pr-2" *ngIf="fleetSettings?.customShopSuppliesType?.value === 'percentage'">
        <app-input id="fleet-shop-supplies-cap" placeholder="Max fees" theme="primary" name="fleet-shop-supplies-cap"
          [allowDecimal]="focus?.customShopSuppliesCap ? true: false" [floatingLabel]="true" [fontSize]="14"
          [isInvalid]="errors?.customShopSuppliesCap" [errorMessage]="errors?.customShopSuppliesCap"
          [value]="focus?.customShopSuppliesCap? fleetSettings?.customShopSuppliesCap: fleetSettings?.customShopSuppliesCap | currency: usd"
          [disabled]="!fleetSettings?.isShopSuppliesOverride" [value]="fleetSettings?.customShopSuppliesCap || ''"
          [selectTextOnFocus]="true" (appFocus)="handleFocus('customShopSuppliesCap')"
          (appBlur)="handleBlur('customShopSuppliesCap')"
          (appKeyUp)="handleAppSettingChange('customShopSuppliesCap', $event)" [theme]="inputTheme">
        </app-input>
      </div>
    </div>
  </div>

  <!-- Tax codes -->
  <div *ngIf="isFleetTaxOverRideEnabled" class="ui-g-12 p-0 mb-4">
    <div class="ui-g-4 p-0 pr-2">
      <app-switch-pill id="fleet-taxcode" label="Apply tax code override" position="end" styleClassLabel="font-gray-35"
        [fontSize]="14" [isActive]="fleetSettings?.isTaxCodeOverride"
        (appChange)="handleAppSettingChange('isTaxCodeOverride', $event)">
      </app-switch-pill>
    </div>

    <div class="ui-g-3 p-0 pr-2">
      <app-dropdown id="fleet-tax-code-select" listId="fleet-tax-code-select-list" placeholder="Enter tax code"
        theme="primary" field="label" [disabled]="!fleetSettings?.isTaxCodeOverride" [hasError]="errors?.customTaxCode"
        [errorMessage]="errors?.customTaxCode" [value]="fleetSettings?.customTaxCode" [fontSize]="14"
        [listItemFontSize]="13" [floatingLabel]="true" [options]="taxCodes" [isDropdownIconVisible]="true"
        (appSelect)="handleAppSettingChange('customTaxCode', $event)" scrollHeight="160px" [theme]="inputTheme">
      </app-dropdown>
    </div>
  </div>

  <div class="ui-g-12 p-0 flex-start-center width-100p mb-4" *ngIf="!isMyFleetCenter">
    <p class="m-0 font-bold font-gray-35 white-space-nowrap pr-2">Service level override</p>
    <div class="horizontal-line width-100p mr-2"></div>
  </div>

  <!-- Labor rate -->
  <div class="ui-g-12 p-0 mb-4">
    <div class="ui-g-4 p-0">
      <app-switch-pill id="fleet-labor-rate" label="Apply labor rate override" position="end"
        styleClassLabel="font-gray-35" [isActive]="fleetSettings?.isLaborRateOverride" [fontSize]="14"
        (appChange)="handleAppSettingChange('isLaborRateOverride', $event)">
      </app-switch-pill>
    </div>

    <div [ngClass]="isMyFleetCenter?'ui-g-3 p-0 pr-2':'ui-g-8 p-0'">
      <app-dropdown id="fleet-labor-rate" listId="fleet-labor-rate-list" placeholder="Select rate" theme="primary"
        field="name" editFieldLabel="Add labor rate" editFieldMask="0*.00" [allowDecimal]="true"
        [disabled]="!fleetSettings?.isLaborRateOverride" [hasError]="errors?.customLaborRate"
        [errorMessage]="errors?.customLaborRate" [minCreateStrLength]="1" [value]="fleetSettings?.customLaborRate"
        [fontSize]="14" [hasEditableField]="true" [listItemFontSize]="13" [floatingLabel]="true"
        [options]="laborPricings" [isDropdownIconVisible]="true"
        (appSelect)="handleAppSettingChange('customLaborRate', $event)" (appSave)="handleSave($event)"
        [theme]="inputTheme">
      </app-dropdown>
    </div>
  </div>


  <!-- Part Pricing matrix -->
  <div class="ui-g-12 p-0 mb-4">
    <div class="ui-g-4 p-0">
      <!-- advance -->
      <app-switch-pill *ngIf="isAttributeBasedPricingEnable" id="fleet-pricing-matrix" label="Apply pricing override for part" position="end"
        styleClassLabel="font-gray-35" [fontSize]="14" [isActive]="fleetSettings?.isPartPricingMatrixOverride"
        (appChange)="handleAppSettingChange('isPartPricingMatrixOverride', $event)">
      </app-switch-pill>

      <!-- old -->
      <app-switch-pill *ngIf="!isAttributeBasedPricingEnable" id="fleet-pricing-matrix" label="Apply pricing matrix override" position="end"
        styleClassLabel="font-gray-35" [fontSize]="14" [isActive]="fleetSettings?.isPricingMatrixOverride"
        (appChange)="handleAppSettingChange('isPricingMatrixOverride', $event)">
      </app-switch-pill>
    </div>

    <div [ngClass]="isMyFleetCenter ? 'ui-g-3 p-0 pr-2' : 'ui-g-8 p-0'">
      <!-- advance -->
      <app-dropdown *ngIf="isAttributeBasedPricingEnable" id="fleet-pricing-matrix" listId="fleet-pricing-matrix-list" placeholder="Select part matrix"
        theme="primary" field="name" [disabled]="!fleetSettings?.isPartPricingMatrixOverride"
        [hasError]="errors?.customPartPricingMatrix" [errorMessage]="errors?.customPartPricingMatrix"
        [value]="fleetSettings?.customPartPricingMatrix" [fontSize]="14" [listItemFontSize]="13" [floatingLabel]="true"
        [options]="partPricings" [isDropdownIconVisible]="true"
        (appSelect)="handleAppSettingChange('customPartPricingMatrix', $event)" [theme]="inputTheme">
      </app-dropdown>
      <!-- old -->
      <app-dropdown *ngIf="!isAttributeBasedPricingEnable" app-dropdown id="fleet-pricing-matrix" listId="fleet-pricing-matrix-list" placeholder="Select matrix"
      theme="primary" field="name" [disabled]="!fleetSettings?.isPricingMatrixOverride"
      [hasError]="errors?.customPartPricingMatrix" [errorMessage]="errors?.customPartPricingMatrix"
      [value]="fleetSettings?.customPartPricingMatrix" [fontSize]="14" [listItemFontSize]="13" [floatingLabel]="true"
      [options]="partPricings" [isDropdownIconVisible]="true"
      (appSelect)="handleAppSettingChange('customPartPricingMatrix', $event)" [theme]="inputTheme">
    </app-dropdown>
    </div>
  </div>

  <!-- Tire  -->
  <div *ngIf="isAttributeBasedPricingEnable" class="ui-g-12 p-0 mb-4">
    <div class="ui-g-4 p-0">
      <app-switch-pill id="fleet-pricing-matrix" label="Apply pricing override for tire" position="end"
        styleClassLabel="font-gray-35" [fontSize]="14" [isActive]="fleetSettings?.isTirePricingMatrixOverride"
        (appChange)="handleAppSettingChange('isTirePricingMatrixOverride', $event)">
      </app-switch-pill>
    </div>

    <div [ngClass]="isMyFleetCenter ? 'ui-g-3 p-0 pr-2' : 'ui-g-8 p-0'">
      <app-dropdown id="fleet-pricing-matrix" listId="fleet-pricing-matrix-list" placeholder="Select tire matrix"
        theme="primary" field="name" [disabled]="!fleetSettings?.isTirePricingMatrixOverride"
        [hasError]="errors?.customTirePricingMatrix" [errorMessage]="errors?.customTirePricingMatrix"
        [value]="fleetSettings?.customTirePricingMatrix" [fontSize]="14" [listItemFontSize]="13" [floatingLabel]="true"
        [options]="tirePricings" [isDropdownIconVisible]="true"
        (appSelect)="handleAppSettingChange('customTirePricingMatrix', $event)" [theme]="inputTheme">
      </app-dropdown>
    </div>
  </div>

  <div class="ui-g-12 p-0 flex-start-center width-100p mb-4" *ngIf="customer.isMFCustomer">
    <p class="m-0 font-bold font-gray-35 white-space-nowrap pr-2">Invoice override</p>
    <div class="horizontal-line width-100p mr-2"></div>
  </div>

  <div class="ui-g-4 p-0 pr-2" *ngIf="customer.isMFCustomer">
    <app-switch-pill id="fleet-driver-details" label="Use driver details on invoice" position="end"
      styleClassLabel="font-gray-35" [fontSize]="14" [isActive]="fleetSettings?.useDriverDetailOnInvoice"
      (appChange)="handleAppSettingChange('useDriverDetailOnInvoice', $event)">
    </app-switch-pill>
  </div>